import { useCallback, useState } from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { SvgIcon } from "@mui/material";
import { ReactComponent as MexalSvg } from "../../../mexal.svg";
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { fetchAPI } from '../../../api/request';
import { API as mexalAPI } from '../../../module/mexal';
import { SendOfMexalConf } from '../../../module/logbook/conf/SendOfMexal.conf';
import ModalSendOfBase from './ModalSendOfBase.component';
import SendOfMexalPreview from '../../listItem/tableEditable/components/SendOfMexalPreview.component';

const ModalSendOfMexal = ({
  id,
  code,
  deliveryNote,
  items = [],
  supplier,
  operationListData,
  setSuccessUpdate = () => {},
  supplierRowIndex,
  ofSended = false,
  ofNumber = 0,
}) => {
  const { jwt } = useSelector((state) => state.login);
  const [loading, setLoading] = useState(false);
  const disabled = loading || _.isEmpty(deliveryNote) || ofSended;
  const mexalCode = _.get(supplier, 'attributes.mexal_code');
  const nameSupplier = _.get(supplier, 'attributes.company_name');
  const yachtName = _.get(operationListData, 'attributes.id_yacht.data.attributes.yacht_name', '');
  const serviceType = _.get(operationListData, 'attributes.id_service.data.attributes.service', '');
  const deliveryNoteNumber = _.get(
    operationListData,
    'attributes.id_delivery_note.data.attributes.delivery_note_number',
    ''
  );
  const noteValue = [yachtName, serviceType, deliveryNoteNumber].filter(Boolean).join(' - ');
  const currentDate = new Date().toLocaleDateString('it-IT');
  const idList = operationListData?.attributes?.id_list?.data?.id ?? 0;
  const number = (idList || supplierRowIndex) ? `${idList}${supplierRowIndex ?? ''}` : 0;
  const normalizedOfNumber = Number(ofNumber);
  const hasOfNumber = Number.isFinite(normalizedOfNumber);
  const showBadgeNumber = ofSended && hasOfNumber && String(normalizedOfNumber).length <= 4;
  const tooltipTitle = ofSended
    ? `OF already sent${hasOfNumber ? ` - Number: ${normalizedOfNumber}` : ''}`
    : 'Send OF to Mexal';

  const onSubmitAction = useCallback(
    (values = {}) => {
      setLoading(true);
      return fetchAPI(
        mexalAPI.sendOf,
        {},
        '',
        {
          data: {
            id_logbook: id,
            department: code,
            note: values?.note || '',
            number,
          },
        },
        jwt
      ).finally(() => {
        setLoading(false);
      });
    },
    [id, code, number, jwt]
  );

  const onCloseSuccess = useCallback(() => {
    setSuccessUpdate((prev) => !prev);
  }, [setSuccessUpdate]);

  return (
    <ModalSendOfBase
      conf={SendOfMexalConf}
      successMessage='OF sent to Mexal successfully'
      onSubmitAction={onSubmitAction}
      onCloseSuccess={onCloseSuccess}
      defaultValues={{ note: noteValue }}
      button={
        <Tooltip title={tooltipTitle}>
          <span>
            <Badge
              color='primary'
              overlap='circular'
              badgeContent={showBadgeNumber ? normalizedOfNumber : null}
            >
              <IconButton color='primary' disabled={disabled}>
                <SvgIcon component={MexalSvg} inheritViewBox sx={{
                  opacity: disabled ? 0.38 : 1,
                  transition: "opacity 0.2s ease",
                }} />
              </IconButton>
            </Badge>
          </span>
        </Tooltip>
      }
    >
      <SendOfMexalPreview
        items={items}
        mexalCode={mexalCode}
        nameSupplier={nameSupplier}
        currentDate={currentDate}
        number={number}
      />
    </ModalSendOfBase>
  );
};

export default ModalSendOfMexal;
